export const onWallConfigChange = (key, value) => {
  return {
    type: "ON_WALL_CONFIG_CHANGE",
    key: key,
    value: value
  }
}

export const onWallConfigCollectionChange = (index, key, value) => {
  return {
    type: "ON_WALL_CONFIG_COLLECTION_CHANGE",
    index: index,
    key: key,
    value: value
  }
}
